import { Input, Tooltip } from "antd";
import { FiAlertCircle } from "react-icons/fi";
import React, { useEffect, useRef, useState } from "react";
import { FaAsterisk } from "react-icons/fa";
import { useMediaQuery } from "react-responsive";

export default function FormInput({
  title = "",
  type = "text",
  placeholder = "",
  value = "",
  icon = "",
  className = "",
  phoneNumber,
  websiteLink,
  change = () => {},
  error = "",
  width = "full",
  description,
  required = false,
  Id = "",
  ref,
  grid = "",
  autoFocus,
  maxLength = 31,
  disabled = false,
  pattern = false,
  inputmode = "",
  variant = "",
  suffixTooltip = "",
  suffixIcon,
  suffixClickable = false,
  showErrorMessage = true,
  onInput,
  Characters = false,
  Alphabet = false,
  allowNegative = false,
}) {
  const isSmallScreen = useMediaQuery({ maxWidth: 1439 });
  const [show, setShow] = useState(false);
  const target = useRef(null);
  const [inputDisable, setinputDisable] = useState(true);
  const [localError, setLocalError] = useState("");
  const [charCount, setCharCount] = useState(0);

  const handleKeyDown = (e) => {
    if (type === "number") {
      if (['e', 'E', '+'].includes(e.key)) {
        e.preventDefault();
      }
      
      if (e.key === '-') {
        if (!allowNegative || e.target.value.includes('-') || e.target.selectionStart !== 0) {
          e.preventDefault();
        }
      }
    }
  };

  const handleChange = (e) => {
    let inputValue = e.target.value;
    let errorMessage = "";

    // Update character count
    setCharCount(inputValue.length);

    // Check character limit
    // if (inputValue.length > maxLength) {
    //   errorMessage = `Maximum ${maxLength-1} characters allowed`;
    // }

    if (type === "number") {
      const numericValue = allowNegative 
        ? inputValue.replace(/[^\d.-]/g, '')
        : inputValue.replace(/[^\d.]/g, '');
      
      const parts = numericValue.split('.');
      if (parts.length > 2) {
        inputValue = parts[0] + '.' + parts.slice(1).join('');
      } else {
        inputValue = numericValue;
      }

      if (allowNegative && inputValue.includes('-')) {
        if (inputValue.indexOf('-') !== 0) {
          inputValue = inputValue.replace(/-/g, '');
          if (inputValue !== '') {
            inputValue = '-' + inputValue;
          }
        }
      }
    } else if (Characters) {
      if (/[^a-zA-Z0-9 ]/.test(inputValue)) {
        errorMessage = "Invalid Character";
      }
    } else if (Alphabet) {
      if (/[^a-zA-Z ]/.test(inputValue)) {
        errorMessage = "Invalid Character";
      }
    }

    if (inputValue.charAt(0) === " ") {
      inputValue = inputValue.slice(1);
    }

    if (inputValue.length > maxLength) {
      inputValue = inputValue.slice(0, maxLength);
    }

    setLocalError(errorMessage);
    change(inputValue);
  };

  return (
    <div
      className={`flex flex-col ${
        title ? "gap-2" : "gap-0 items-center"
      } ${grid}`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center text-green-600 font-bold gap-0.5">
          {title && (
            <label htmlFor="" className="text-[#16A34A] text-[16px] md:text-[12px] 2xl:text-[16px] font-medium leading-[19.2px] break-words font-plus-jakarta-sans">
              {title}
            </label>
          )}
          {required && <FaAsterisk className="text-[6px] text-rose-600" />}
        </div>
        {/* <span className="text-[12px] text-gray-500">
          {charCount}/{maxLength}
        </span> */}
      </div>
      <span className={`relative ${className}`}>
        <Input
          onWheel={(e) => {
            e.currentTarget.blur();
          }}
          onKeyDown={handleKeyDown}
          onInput={onInput}
          id={Id}
          type={type}
          pattern={pattern}
          inputmode={inputmode}
          placeholder={` ${placeholder}`}
          className={`w-full ${error || localError ? "border-rose-400" : ""}`}
          value={value === "NAN" ? "" : value}
          onChange={handleChange}
          status={error || localError ? "error" : ""}
          size={isSmallScreen ? "default" : "large"}
          prefix={icon && icon}
          suffix={
            <Tooltip title={suffixTooltip}>
              <div
                onClick={
                  suffixClickable === true &&
                  (() => setinputDisable(!inputDisable))
                }
                className="cursor-pointer z-50"
              >
                {suffixIcon && suffixIcon}
              </div>
            </Tooltip>
          }
          variant={variant ? variant : "outlined"}
          style={
            error || localError
              ? {
                  boxShadow:
                    "0px 0px 0px 4px #FEE4E2, 0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
                }
              : {}
          }
          disabled={suffixClickable ? inputDisable : disabled}
          autoFocus={autoFocus}
        />

        {/* {(error || localError) && (
          <FiAlertCircle
            className={`absolute top-2.5 right-2 mr-3 transform -translate-y-1/5 text-red-400`}
          />
        )} */}

        {(error || localError) && showErrorMessage && (
          <p className="flex justify-start items-center  my-1 mb-0 text-[10px] text-red-600">
            <span className="text-[10px] pt-2">{error || localError}</span>
          </p>
        )}
      </span>
      {description && (
        <p className="2xl:text-sm text-xs font-normal opacity-70 dark:text-white">
          {description}
        </p>
      )}
    </div>
  );
}